import { render, staticRenderFns } from "./AboveColumn.vue?vue&type=template&id=d0159ba8"
import script from "./AboveColumn.vue?vue&type=script&lang=js"
export * from "./AboveColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports